var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7V8C7 8.34247 7.03443 8.67689 7.10002 9C7.56329 11.2822 9.58104 13 12 13C14.419 13 16.4367 11.2822 16.9 9C16.9656 8.67689 17 8.34247 17 8V7H15H9H7ZM10 5H14V3C14 2.44772 14.4477 2 15 2C15.5523 2 16 2.44772 16 3V5H17C18.1046 5 19 5.89543 19 7V8C19 11.5265 16.3923 14.4439 13 14.9291V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V14.9291C7.60771 14.4439 5 11.5265 5 8V7C5 5.89543 5.89543 5 7 5H8V3C8 2.44772 8.44772 2 9 2C9.55228 2 10 2.44772 10 3V5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocket);
export default __webpack_public_path__ + "static/media/socket.1822284c832b4a489e02da34272185be.svg";
export { ForwardRef as ReactComponent };